import React, { useState } from "react";
import {
    experimentalStyled,
    useMediaQuery,
    Container,
    Box
} from "@mui/material";
import Sidebar from "./sidebar/Sidebar";
import Header from "./header/Header";
// import Footer from "./footer/Footer";
// import Customizer from './customizer/Customizer';
import { TopbarHeight } from "../../assets-v2/global/Theme-variable";

const MainWrapper = experimentalStyled("div")(() => ({
    display: "flex",
    minHeight: "100vh",
    overflow: "hidden",
    width: "100%"
}));
const PageWrapper = experimentalStyled("div")(({ theme }) => ({
    display: "flex",
    flex: "1 1 auto",
    overflow: "hidden",

    backgroundColor: theme.palette.background.default,
    [theme.breakpoints.up("lg")]: {
        paddingTop: TopbarHeight
    },
    [theme.breakpoints.down("lg")]: {
        paddingTop: "64px"
    }
}));

const FullLayout = ({ children }) => {
    const INIT_STATE = {
        activeDir: "ltr",
        activeNavbarBg: "#0b70fb",
        activeSidebarBg: "#ffffff",
        activeMode: "light",
        activeTheme: "ORANGE_THEME",
        SidebarWidth: 240
    };
    const [isSidebarOpen, setSidebarOpen] = useState(true);
    const [isMobileSidebarOpen, setMobileSidebarOpen] = useState(false);
    const customizer = INIT_STATE;
    const lgUp = useMediaQuery(theme => theme.breakpoints.up("lg"));
    return (
        <MainWrapper
            className={customizer.activeMode === "dark" ? "darkbg" : ""}
        >
            <Header
                sx={{
                    paddingLeft: isSidebarOpen && lgUp ? "265px" : "",
                    backgroundColor:
                        customizer.activeMode === "dark" ? "#20232a" : "#fafbfb"
                }}
                toggleSidebar={() => setSidebarOpen(!isSidebarOpen)}
                toggleMobileSidebar={() => setMobileSidebarOpen(true)}
            />

            <Sidebar
                isSidebardir={customizer.activeDir === "ltr" ? "left" : "right"}
                isSidebarOpen={isSidebarOpen}
                isMobileSidebarOpen={isMobileSidebarOpen}
                onSidebarClose={() => setMobileSidebarOpen(false)}
            />

            <PageWrapper>
                <Container
                    maxWidth={false}
                    sx={{
                        paddingTop: "20px",
                        paddingLeft:
                            isSidebarOpen && lgUp ? "280px!important" : ""
                    }}
                >
                    <Box sx={{ minHeight: "calc(100vh - 170px)" }}>
                        {/* <Outlet /> */}
                        {children}
                    </Box>
                    {/* <Customizer /> */}
                    {/* <Footer /> */}
                </Container>
            </PageWrapper>
        </MainWrapper>
    );
};

export default FullLayout;
